import { KaaPTenantEntityPage as KaaPTenantEntityPageInner } from '@internal/backstage-plugin-kaap';
import React from 'react';

import { ActionContent, EntityWarningContent } from '../Content';

export const KaaPTenantEntityPage = (
  <KaaPTenantEntityPageInner
    ActionContent={ActionContent}
    EntityWarningContent={<EntityWarningContent />}
  />
);
